// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.App-header {
  background-color: var(--hydros-blue);
  height: 7vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: calc(10px + 2vmin);
  padding: 15px;
}

.logo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}

.logo-text {
  font-size: 32px;
  color: var(--hydros-sand);
  font-weight: 600;
}

.App-logo {
  max-height: 10vh;
}

.loader-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.loader {
  width: 100px;
  height: 100px;
}

@keyframes spin-anim {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.content {
  height: calc(100% - 7vh);
  padding-top: 20px;
}

.content-danger {
  background: #bc1f1f;
  padding-top: 20px;
  height: calc(100% - 7vh);
}

.card {
  margin: 0px 10px 25px 10px;
  justify-content: center;
  flex-basis: calc(25% - 20px);
  display: flex;
}

.cards {
  display: flex;
  flex-wrap: wrap;
}

.card-content {
  width: 300px;
  height: 330px;
  cursor: pointer;
  position: relative;
  background-size: auto 90%;
  background-repeat: no-repeat;
  background-color: black;
  box-shadow: 10px 10px 0px var(--hydros-mid-blue);
}

.card-details-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.overlay {
  position: absolute;
  width: 300px;
  height: 330px;
  background: rgba(250, 250, 250, 0.4);
  z-index: 250;
}

.overlay-check {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 15px;
  right: 15px;
}

.card-title {
  margin: 5px;
  min-height: 50px;
  color: white;
}

.card-cost-top {
  min-width: 55px;
}

.card-title-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 5px 10px 0px 0px;
}

.card-title-back {
  margin: 5px;
  font-size: 17px;
}

.card-info {
  position: absolute;
  width: 100%;
  bottom: 0;
  height: auto;
  background: linear-gradient(rgb(255, 255, 255, 0), 10%, black);
}

.card-description {
  margin: 5px 5px;
  font-size: 13px;
}

.card-bottom {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: white;
  margin: 10px 15px;
}

.details-button {
  height: 30px;
  width: 30px;
  cursor: pointer;
  background-color: var(--hydros-blue);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  border: none;
}

.card-cost {
  margin: 0px;
  font-size: 21px;
}

.currency {
  margin-left: 5px;
  width: 25px;
  height: 25px;
  position: relative;
  top: 0px;
}

.card-water-saving {
  font-size: 21px;
  margin: 0px;
  display: flex;
  align-items: center;
}

.card-water-saving-drop {
  height: 25px;
  margin-left: 5px;
}

.budgets {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}

.budget {
  margin: 0px;
  font-size: 31px;
}

.budget-currency {
  margin-left: 5px;
  width: 30px;
  height: 30px;
  top: 0px;
  position: relative;
}

.water-budget {
  font-size: 24px;
  margin: 0px;
  margin-left: 10px;
  line-height: 15px;
  display: flex;
  align-items: center;
}

.color-sand {
  color: var(--hydros-sand);
}

.water-budget-drop {
  height: 30px;
  margin-left: 5px;
}

.water-budget-drop-small {
  height: 25px;
  margin-left: 5px;
}

.validate-section {
  display: block;
  width: 270px;
  margin: auto;
}

.blue-button {
  height: 45px;
  padding: 0px 20px;
  margin-bottom: 10px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-blue);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border: none;
}

.video-display {
  height: 60vh;
}

.blue-button:hover {
  background-color: var(--hydros-mid-blue);
}

.orange-button {
  height: 45px;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 15px;
  cursor: pointer;
  background-color: var(--hydros-orange);
  transition: background-color 0.5s ease;
  color: white;
  font-weight: 600;
  font-size: 18px;
  border: none;
}

.orange-button:hover {
  background-color: #faa08a;
}

.center_element {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.consequence-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90%;
}

.consequence {
  height: 60vh;
  transition: opacity 1s ease;
}

.consequence-container {
  max-width: 600px;
  height: 60vh;
}

.visible {
  opacity: 1;
  height: auto;
}

.hidden {
  opacity: 0;
  height: 0;
  overflow: hidden;
}

.next {
  text-align: center;
  font-size: 70px;
  cursor: pointer;
  color: var(--hydros-orange);
}

.next:hover {
  color: #faa08a;
}

.vertical-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.workshop-image {
  width: 300px;
  border-radius: 15px;
  margin: 20px;
}

.workshop-button-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.home-title {
  font-size: 31px;
  color: var(--hydros-blue);
}

.card-image {
  width: 100%;
  border-radius: 15px;
}

.round {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--hydros-sand);
}

.popularity {
  height: 35px;
}

.consequence-image {
  max-height: 60vh;
}

.recap-text {
  text-align: center;
  padding: 0px 15px;
  margin-bottom: 25px;
}

.recap-text-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.grid-radar-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.evolution-chart {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.evolution-chart-container {
  display: block;
  position: relative;
  max-height: 450px;
  width: 600px;
  margin: auto;
}

.water-budget-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px 20px;
}

.gauge-container {
  width: 100px;
  display: block;
  height: 30px;
  border: 3px solid lightgray;
  border-radius: 3px;
  background-color: white;
  margin: 0 10px;
}

.width-200p {
  width: 200px;
}

.gauge-content {
  background-color: var(--hydros-light-blue);
  height: 30px;
}

.no-bold {
  font-weight: 600;
}

.chart-display {
  height: 400px;
  width: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 5px solid var(--hydros-blue);
  border-radius: 15px;
  padding: 15px;
}

.chart-title-position {
  top: 10px;
  left: 0px;
}

.chart-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  gap: 25px;
}

.map-container {
  height: 600px;
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 15px;
}

.mapboxgl-map {
  border-radius: 50px;
}

.bar-content {
  max-width: 250px;
  position: absolute;
  bottom: 0;
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: black;
  margin: 10px 15px;
}

.actors_global_container {
  font-size: 17px;
}

.actor-name {
  margin: 0px;
}

.actor-budget {
  padding: 10px;
  border-radius: 15px;
  text-align: center;
}

.budgets-container {
  margin-bottom: 25px;
  display: flex;
}

.budget-container {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15px;
}

.text-intro-container {
  text-align: justify;
  padding: 15px;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 15px;
  border: solid 4px var(--hydros-orange);
  border-radius: 25px;
  font-size: 20px;
  font-weight: 500;
  color: var(--hydros-blue);
}

.text-intro-title {
  text-align: center;
  font-size: 32px;
  padding: 10px;
  font-size: 40px;
  color: var(--hydros-blue);
  font-weight: bold;
}

.next-intro-section {
  text-align: center;
  padding: 15px;
}

.game-intro-image {
  display: block;
  max-height:70vh;
  max-width: 100%;
  width: auto;
  height: auto;
  margin-bottom: 20px;
}

.game-intro-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.game-intro-controls {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
}

.game-intro-end-container {
  width: 40%;
}

.warning-image {
  width: 40px;
  height: 40px;
  margin-left: 10px;
}

.inline-icon {
  vertical-align: middle;
}

.meteo {
  width: 300px;
  border-radius: 15px;
}

.radar-container {
  width: 450px;
  height: 450px;
  border: 5px solid var(--hydros-blue);
  border-radius: 15px;
}

.chart-title {
  text-align: center;
  margin: 15px;
  font-size: 24px;
  font-weight: 600;
  color: var(--hydros-blue);
  position: absolute;
}

.selector_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin-bottom: 20px;
}

.selector_container .name {
  font-size: 18px;
  margin-right: 5px;
}
/* Switch button container */
.switch-button {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

/* Hide default checkbox input */
.switch-button input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Rounded slider (le bouton lui-même) */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  transition: 0.4s;
  border-radius: 50%;
}

/* Styling when the switch button is checked (toggled on) */
input:checked + .slider {
  background-color: var(--hydros-blue);
}

input:checked + .slider:before {
  transform: translateX(29px);
}

.actor_choicer_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border: var(--hydros-blue) solid 3px;
  border-radius: 20px;
  width: 80%;
  margin-left: 10%;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.actor_budget_container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.add_actor_choicer {
  background-color: var(--hydros-blue);
  border-radius: 20px;
  width: 50px;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  margin: 0 auto;
  cursor: pointer;
  padding-left: 4px;
  color: white;
}

.add_actor_choicer:hover {
  background-color: white;
  border: 1px solid var(--hydros-blue);
  color: var(--hydros-blue);
}

.header_selection_container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.num_actor_text {
}

.input_name_actor {
  /* font-size: 20px; */
  border-radius: 5px;
  padding: 4px;
  color: #393939;
  font-weight: bold;
  border: 2px solid gray;
}

.input_budget_actor {
  /* font-size: 20px; */
  border-radius: 5px;
  padding: 4px;
  color: #393939;
  width: 50px;
  font-weight: bold;
  border: 2px solid gray;
}

.actor_budget_title {
  margin-right: 5px;
  color: grey;
  font-weight: bold;
}

.additional_game_selection_container {
  width: 100%;
  font-size: 18px;
  color: var(--hydros-blue);
  font-weight: 600;
}

.custom-select {
  position: relative;
  display: inline-block;
  border: 1px solid var(--hydros-orange);
  border-radius: 4px;
  padding: 1px 0px;
  margin-bottom: 20px;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
  width: 100%;
  background: white;
}

.custom-select .select-button {
  padding: 10px;
  background-color: #fff;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-size: 16px;
  border-radius: 10px;
  color: var(--hydros-blue);
}

.custom-select .options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid var(--hydros-orange);
  border-radius: 4px;
  font-size: 16px;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 1;
}

.custom-select .option {
  padding: 10px;
  cursor: pointer;
}

.custom-select .option.active {
  background-color: var(--hydros-blue);
  color: #fff;
}

.info_upper_container {
  display: flex;
  align-items: center;
}

.info_icon_container {
  position: relative;
  cursor: pointer;
  margin-left: 5px;
  font-size: 12px;
}

.tooltip {
  position: absolute;
  top: 0;
  left: 100%;
  /* Add any other styling for the tooltip */
  padding: 5px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 300px;
}

.profile-page {
  margin-left: 30px;
  margin-right: 30px;
}

.profile-top-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.profile-config-container {
  background-color: #e5e5e5;
  border-radius: 20px;
  padding-left: 20px;
  padding-bottom: 10px;
}

.profile-select-workshop {
  border-radius: 20px;
  padding: 5px;
  font-size: 15px;
  font-weight: bold;
  color: white;
  background: var(--hydros-blue);
  border: none;
}

.stats-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 20px;
  margin-top: 5px;
}

.stat-container {
  background-color: var(--hydros-blue);
  padding: 20px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20%;
}

.stat-header {
  color: white;
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 20px;
  text-align: center;
}

.stat-value {
  color: white;
  font-weight: bold;
  font-size: 50px;
}

.stat-logo {
  height: 50px;
}

.profile-workshop-title {
}

.new-workshop-button {
  width: 270px;
  margin-bottom: 0px;
}

.workshop-date {
  font-style: italic;
}

.workshop-status {
  width: auto;
  border-radius: 12px;
  color: white;
  text-align: center;

  padding: 2px 10px;
  margin-top: 10px;
}
.workshop-type {
  width: auto;
  border-radius: 12px;
  color: white;
  text-align: center;
  padding: 2px 10px;
  margin-top: 10px;
}

.labels-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0px 20px;
  flex-wrap: wrap;
}

.workshop-bottom-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  color: var(--hydros-blue);
}

.no-margin {
  margin: 0;
}

.workshop-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border: solid var(--hydros-blue) 4px;
  border-radius: 20px;
  padding: 15px;
  max-width: 400px;
}

.workshops-list {
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 15px;
}

.workshop-name {
  font-size: 22px;
  text-align: center;
  color: var(--hydros-orange);
  font-weight: bold;
}

.workshop-button {
}

.login-page {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 89vh;
}

.login-container {
  padding: 15px 30px;
  border-radius: 15px;
  background-color: var(--hydros-sand);
}

.login-title {
  margin: 0 0 30px 0;
  color: var(--hydros-orange);
  font-size: 30px;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-input-container {
  font-size: 18px;
  padding: 10px;
  margin-bottom: 20px;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
}

.form-input-container:focus {
  border: 2px solid var(--hydros-orange);
}

.form-container {
  width: 400px;
  margin: 20px auto;
  padding: 20px;
  background: var(--hydros-sand);
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-top-title {
  font-size: 40px;
  margin-bottom: 50px;
  color: var(--hydros-blue);
}

.bad-login-div {
  border: solid rgb(177, 14, 14) 2px;
  padding: 8px 0px;
  font-size: 13px;
  color: rgb(202, 23, 23);
  background: rgb(228, 181, 181);
  border-radius: 10px;
  margin-bottom: 15px;
  width: 100%;
}

.icon {
  font-size: 16px;
}

.card-indicators {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: center;
}

.card-indicator {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.color-blue {
  color: var(--hydros-blue);
}

.input {
  font-size: 18px;
  padding: 10px;
  margin-bottom: 20px;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
  width: calc(100% - 20px);
}

.input-label {
  margin-bottom: 10px;
}

.recap-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 50px;
  width: 100%;
  margin-top: 25px;
}

.back-to-game {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 25px;
  padding: 15px;
  border-radius: 15px;
  background: var(--hydros-orange);
  color: white;
  margin-right: 25px;
  bottom: 0;
  cursor: pointer;
  align-self: flex-end;
}

.back-to-game:hover {
  background-color: #faa08a;
}

.happening-text {
  text-align: center;
  max-width: 800px;
  font-size: 18px;
  color: var(--hydros-blue);
  font-weight: 600;
}

.green-bg {
  color: white;
  background-color: #176736;
}

.blue-bg {
  color: white;
  background-color: #0e4596;
}

.white-bg {
  color: var(--hydros-blue);
  background-color: white;
  border: 2px solid var(--hydros-blue);
}

.red-bg {
  color: white;
  background-color: #c72f30;
}

.orange-bg {
  color: white;
  background-color: #ff5b2d;
}
.yellow-bg {
  color: var(--hydros-blue);
  background-color: #ffcf31;
}
.purple-bg {
  color: white;
  background-color: #65326b;
}
.gray-bg {
  color: white;
  background-color: #736e6a;
}

.pink-bg {
  color: white;
  background-color: #f85ca5;
}

.default-bg {
  color: white;
  background-color: var(--hydros-blue);
}

.tuto-video {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px;
}

.card-bottom-back {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}

.datepicker-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.ticket-price {
  font-size: 18px;
  padding: 10px;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
  width: 50px;
  margin-right: 5px;
}

.workshop-description {
  font-size: 16px;
  padding: 10px;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
  width: calc(100% - 20px);
  resize: none;
}

.description-container {
  margin: 15px 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ticket-price-container {
  margin: 15px 0px 0px 0px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.ticket-price-tooltip {
  font-size: 14px;
  margin-bottom: 20px;
  text-align: end;
  margin-top: 5px;
}

.address-container {
  margin-top: 20px;
}

.workshop-address {
  font-size: 18px;
  padding: 10px;
  margin: 10px 0;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
  width: calc(100% - 20px);
}

.workshop-city {
  font-size: 18px;
  padding: 10px;
  margin: 10px 0px 10px 15px;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
  width: calc(50% - 39px);
}

.workshop-postal-code {
  font-size: 18px;
  padding: 10px;
  margin: 10px 15px 10px 0px;
  border: 2px solid var(--hydros-orange);
  border-radius: 10px;
  width: calc(50% - 39px);
}

.ticketing-link {
  cursor: pointer;
  margin-top: 10px;
}

.ticketing-icon {
  color: var(--hydros-blue);
  font-size: 20px;
}

.ticketing-explanation {
  margin-bottom: 20px;
  text-align: left;
  font-size: 14px;
  font-weight: 450;
}

.validate-parameters {
  font-size: 18px;
  color: var(--hydros-blue);
  font-weight: 600;
  margin-bottom: 10px;
}

.profile-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.game-summary-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /*height: 100vh;  Utilisez 100vh pour occuper 100% de la hauteur de la fenêtre */
}

.context-container {
  display: block;
  position: relative;
  max-height: 1000px;
  width: 600px;
  margin: auto;
  border: 5px solid var(--hydros-blue);
  border-radius: 15px;
}

.final-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}

.final-form-input {
  font-size: 18px;
  padding: 10px;
  margin-bottom: 20px;
  border: 2px solid var(--hydros-blue);
  border-radius: 10px;
}

.final-form-result {
  padding: 20px;
  text-align: center;
  color: #205673;
  font-size: 25px;
  font-weight: 600;
}

.game-summary-title {
  font-size: 40px; 
  color: var(--hydros-blue);
  margin-bottom: 0px }

.game-summary-subtitle {
  font-size: 35px; 
  color: var(--hydros-mid-blue);
  margin: 0px }

.game-summary-list {
  font-size: 20px; 
  color: var(--hydros-blue);
  padding : 0;
  list-style-type: none }
  
.game-summary-text{
  font-size: 20px; 
  color: var(--hydros-blue);
  margin : 0}

.game-summary-bold-text{
  font-size: 20px; 
  font-weight: bold;
  color: var(--hydros-orange);}

.game-summary-number{
  font-size: 35px; 
  font-weight: bold;
  color: var(--hydros-orange);
  margin:0}

.game-summary-subcontainer-left{
  text-align: center;
  display: flex;
  flex-direction: column;
  align-content: space-around;
  margin-left : 25px;
}
.game-summary-subcontainer-bottom-left{
  text-align: center;
  display: flex;
  flex-direction: column;
  align-content: space-around;
  margin-left : 100px;
}
.game-summary-subcontainer-right{
  text-align: center;
  display: flex;
  flex-direction: column;
  align-content: space-around;
  margin-right : 100px;
}

.game-summary-grouped-container{
  text-align: center;
  display: flex;
  align-items: center;
}

.game-summary-icon{
  font-size: 70px;
  color: var(--hydros-orange);
  align-items: center;
}

.game-summary-blue-icon{
  font-size: 70px;
  color: var(--hydros-blue);
  align-items: center;
  margin-bottom: 10px;
}

.separator{
  margin-bottom: 30px;
}


.qrcode-container {
  margin-bottom: 20px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,8DAA8D;AAChE;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;AACA;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,0CAA0C;EAC1C,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;;EAElB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;;AAErB;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;;AAEd;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,sBAAsB;;AAExB;EACE,eAAe;EACf,yBAAyB;EACzB,UAAU;;AAEZ;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B,CAAC;;AAE9B;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,QAAQ;;AAEV;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.App-header {\n  background-color: var(--hydros-blue);\n  height: 7vh;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  font-size: calc(10px + 2vmin);\n  padding: 15px;\n}\n\n.logo-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.logo-text {\n  font-size: 32px;\n  color: var(--hydros-sand);\n  font-weight: 600;\n}\n\n.App-logo {\n  max-height: 10vh;\n}\n\n.loader-container {\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.loader {\n  width: 100px;\n  height: 100px;\n}\n\n@keyframes spin-anim {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.content {\n  height: calc(100% - 7vh);\n  padding-top: 20px;\n}\n\n.content-danger {\n  background: #bc1f1f;\n  padding-top: 20px;\n  height: calc(100% - 7vh);\n}\n\n.card {\n  margin: 0px 10px 25px 10px;\n  justify-content: center;\n  flex-basis: calc(25% - 20px);\n  display: flex;\n}\n\n.cards {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.card-content {\n  width: 300px;\n  height: 330px;\n  cursor: pointer;\n  position: relative;\n  background-size: auto 90%;\n  background-repeat: no-repeat;\n  background-color: black;\n  box-shadow: 10px 10px 0px var(--hydros-mid-blue);\n}\n\n.card-details-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.overlay {\n  position: absolute;\n  width: 300px;\n  height: 330px;\n  background: rgba(250, 250, 250, 0.4);\n  z-index: 250;\n}\n\n.overlay-check {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n.card-title {\n  margin: 5px;\n  min-height: 50px;\n  color: white;\n}\n\n.card-cost-top {\n  min-width: 55px;\n}\n\n.card-title-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin: 5px 10px 0px 0px;\n}\n\n.card-title-back {\n  margin: 5px;\n  font-size: 17px;\n}\n\n.card-info {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  height: auto;\n  background: linear-gradient(rgb(255, 255, 255, 0), 10%, black);\n}\n\n.card-description {\n  margin: 5px 5px;\n  font-size: 13px;\n}\n\n.card-bottom {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n  margin: 10px 15px;\n}\n\n.details-button {\n  height: 30px;\n  width: 30px;\n  cursor: pointer;\n  background-color: var(--hydros-blue);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  border: none;\n}\n\n.card-cost {\n  margin: 0px;\n  font-size: 21px;\n}\n\n.currency {\n  margin-left: 5px;\n  width: 25px;\n  height: 25px;\n  position: relative;\n  top: 0px;\n}\n\n.card-water-saving {\n  font-size: 21px;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n}\n\n.card-water-saving-drop {\n  height: 25px;\n  margin-left: 5px;\n}\n\n.budgets {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 10px;\n}\n\n.budget {\n  margin: 0px;\n  font-size: 31px;\n}\n\n.budget-currency {\n  margin-left: 5px;\n  width: 30px;\n  height: 30px;\n  top: 0px;\n  position: relative;\n}\n\n.water-budget {\n  font-size: 24px;\n  margin: 0px;\n  margin-left: 10px;\n  line-height: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.color-sand {\n  color: var(--hydros-sand);\n}\n\n.water-budget-drop {\n  height: 30px;\n  margin-left: 5px;\n}\n\n.water-budget-drop-small {\n  height: 25px;\n  margin-left: 5px;\n}\n\n.validate-section {\n  display: block;\n  width: 270px;\n  margin: auto;\n}\n\n.blue-button {\n  height: 45px;\n  padding: 0px 20px;\n  margin-bottom: 10px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-blue);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n}\n\n.video-display {\n  height: 60vh;\n}\n\n.blue-button:hover {\n  background-color: var(--hydros-mid-blue);\n}\n\n.orange-button {\n  height: 45px;\n  width: 100%;\n  margin-bottom: 10px;\n  border-radius: 15px;\n  cursor: pointer;\n  background-color: var(--hydros-orange);\n  transition: background-color 0.5s ease;\n  color: white;\n  font-weight: 600;\n  font-size: 18px;\n  border: none;\n}\n\n.orange-button:hover {\n  background-color: #faa08a;\n}\n\n.center_element {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n\n.consequence-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 90%;\n}\n\n.consequence {\n  height: 60vh;\n  transition: opacity 1s ease;\n}\n\n.consequence-container {\n  max-width: 600px;\n  height: 60vh;\n}\n\n.visible {\n  opacity: 1;\n  height: auto;\n}\n\n.hidden {\n  opacity: 0;\n  height: 0;\n  overflow: hidden;\n}\n\n.next {\n  text-align: center;\n  font-size: 70px;\n  cursor: pointer;\n  color: var(--hydros-orange);\n}\n\n.next:hover {\n  color: #faa08a;\n}\n\n.vertical-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.workshop-image {\n  width: 300px;\n  border-radius: 15px;\n  margin: 20px;\n}\n\n.workshop-button-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n}\n\n.home-title {\n  font-size: 31px;\n  color: var(--hydros-blue);\n}\n\n.card-image {\n  width: 100%;\n  border-radius: 15px;\n}\n\n.round {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--hydros-sand);\n}\n\n.popularity {\n  height: 35px;\n}\n\n.consequence-image {\n  max-height: 60vh;\n}\n\n.recap-text {\n  text-align: center;\n  padding: 0px 15px;\n  margin-bottom: 25px;\n}\n\n.recap-text-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.grid-radar-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.evolution-chart {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.evolution-chart-container {\n  display: block;\n  position: relative;\n  max-height: 450px;\n  width: 600px;\n  margin: auto;\n}\n\n.water-budget-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0px 20px;\n}\n\n.gauge-container {\n  width: 100px;\n  display: block;\n  height: 30px;\n  border: 3px solid lightgray;\n  border-radius: 3px;\n  background-color: white;\n  margin: 0 10px;\n}\n\n.width-200p {\n  width: 200px;\n}\n\n.gauge-content {\n  background-color: var(--hydros-light-blue);\n  height: 30px;\n}\n\n.no-bold {\n  font-weight: 600;\n}\n\n.chart-display {\n  height: 400px;\n  width: 600px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 5px solid var(--hydros-blue);\n  border-radius: 15px;\n  padding: 15px;\n}\n\n.chart-title-position {\n  top: 10px;\n  left: 0px;\n}\n\n.chart-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 25px;\n  gap: 25px;\n}\n\n.map-container {\n  height: 600px;\n  width: 90%;\n  margin-left: 5%;\n  margin-right: 5%;\n  margin-top: 15px;\n}\n\n.mapboxgl-map {\n  border-radius: 50px;\n}\n\n.bar-content {\n  max-width: 250px;\n  position: absolute;\n  bottom: 0;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  color: black;\n  margin: 10px 15px;\n}\n\n.actors_global_container {\n  font-size: 17px;\n}\n\n.actor-name {\n  margin: 0px;\n}\n\n.actor-budget {\n  padding: 10px;\n  border-radius: 15px;\n  text-align: center;\n}\n\n.budgets-container {\n  margin-bottom: 25px;\n  display: flex;\n}\n\n.budget-container {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 15px;\n}\n\n.text-intro-container {\n  text-align: justify;\n  padding: 15px;\n  margin-left: 5%;\n  margin-right: 5%;\n  margin-top: 15px;\n  border: solid 4px var(--hydros-orange);\n  border-radius: 25px;\n  font-size: 20px;\n  font-weight: 500;\n  color: var(--hydros-blue);\n}\n\n.text-intro-title {\n  text-align: center;\n  font-size: 32px;\n  padding: 10px;\n  font-size: 40px;\n  color: var(--hydros-blue);\n  font-weight: bold;\n}\n\n.next-intro-section {\n  text-align: center;\n  padding: 15px;\n}\n\n.game-intro-image {\n  display: block;\n  max-height:70vh;\n  max-width: 100%;\n  width: auto;\n  height: auto;\n  margin-bottom: 20px;\n}\n\n.game-intro-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.game-intro-controls {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.game-intro-end-container {\n  width: 40%;\n}\n\n.warning-image {\n  width: 40px;\n  height: 40px;\n  margin-left: 10px;\n}\n\n.inline-icon {\n  vertical-align: middle;\n}\n\n.meteo {\n  width: 300px;\n  border-radius: 15px;\n}\n\n.radar-container {\n  width: 450px;\n  height: 450px;\n  border: 5px solid var(--hydros-blue);\n  border-radius: 15px;\n}\n\n.chart-title {\n  text-align: center;\n  margin: 15px;\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--hydros-blue);\n  position: absolute;\n}\n\n.selector_container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row;\n  margin-bottom: 20px;\n}\n\n.selector_container .name {\n  font-size: 18px;\n  margin-right: 5px;\n}\n/* Switch button container */\n.switch-button {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 30px;\n}\n\n/* Hide default checkbox input */\n.switch-button input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* Rounded slider (le bouton lui-même) */\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 30px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 22px;\n  width: 22px;\n  left: 4px;\n  bottom: 4px;\n  background-color: #fff;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\n/* Styling when the switch button is checked (toggled on) */\ninput:checked + .slider {\n  background-color: var(--hydros-blue);\n}\n\ninput:checked + .slider:before {\n  transform: translateX(29px);\n}\n\n.actor_choicer_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  border: var(--hydros-blue) solid 3px;\n  border-radius: 20px;\n  width: 80%;\n  margin-left: 10%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.actor_budget_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.add_actor_choicer {\n  background-color: var(--hydros-blue);\n  border-radius: 20px;\n  width: 50px;\n  text-align: center;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  margin: 0 auto;\n  cursor: pointer;\n  padding-left: 4px;\n  color: white;\n}\n\n.add_actor_choicer:hover {\n  background-color: white;\n  border: 1px solid var(--hydros-blue);\n  color: var(--hydros-blue);\n}\n\n.header_selection_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.num_actor_text {\n}\n\n.input_name_actor {\n  /* font-size: 20px; */\n  border-radius: 5px;\n  padding: 4px;\n  color: #393939;\n  font-weight: bold;\n  border: 2px solid gray;\n}\n\n.input_budget_actor {\n  /* font-size: 20px; */\n  border-radius: 5px;\n  padding: 4px;\n  color: #393939;\n  width: 50px;\n  font-weight: bold;\n  border: 2px solid gray;\n}\n\n.actor_budget_title {\n  margin-right: 5px;\n  color: grey;\n  font-weight: bold;\n}\n\n.additional_game_selection_container {\n  width: 100%;\n  font-size: 18px;\n  color: var(--hydros-blue);\n  font-weight: 600;\n}\n\n.custom-select {\n  position: relative;\n  display: inline-block;\n  border: 1px solid var(--hydros-orange);\n  border-radius: 4px;\n  padding: 1px 0px;\n  margin-bottom: 20px;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n  width: 100%;\n  background: white;\n}\n\n.custom-select .select-button {\n  padding: 10px;\n  background-color: #fff;\n  border: none;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 10px;\n  color: var(--hydros-blue);\n}\n\n.custom-select .options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid var(--hydros-orange);\n  border-radius: 4px;\n  font-size: 16px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  z-index: 1;\n}\n\n.custom-select .option {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.custom-select .option.active {\n  background-color: var(--hydros-blue);\n  color: #fff;\n}\n\n.info_upper_container {\n  display: flex;\n  align-items: center;\n}\n\n.info_icon_container {\n  position: relative;\n  cursor: pointer;\n  margin-left: 5px;\n  font-size: 12px;\n}\n\n.tooltip {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  /* Add any other styling for the tooltip */\n  padding: 5px;\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 300px;\n}\n\n.profile-page {\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.profile-top-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.profile-config-container {\n  background-color: #e5e5e5;\n  border-radius: 20px;\n  padding-left: 20px;\n  padding-bottom: 10px;\n}\n\n.profile-select-workshop {\n  border-radius: 20px;\n  padding: 5px;\n  font-size: 15px;\n  font-weight: bold;\n  color: white;\n  background: var(--hydros-blue);\n  border: none;\n}\n\n.stats-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  margin-bottom: 20px;\n  margin-top: 5px;\n}\n\n.stat-container {\n  background-color: var(--hydros-blue);\n  padding: 20px;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 20%;\n}\n\n.stat-header {\n  color: white;\n  font-weight: bold;\n  margin-bottom: 10px;\n  font-size: 20px;\n  text-align: center;\n}\n\n.stat-value {\n  color: white;\n  font-weight: bold;\n  font-size: 50px;\n}\n\n.stat-logo {\n  height: 50px;\n}\n\n.profile-workshop-title {\n}\n\n.new-workshop-button {\n  width: 270px;\n  margin-bottom: 0px;\n}\n\n.workshop-date {\n  font-style: italic;\n}\n\n.workshop-status {\n  width: auto;\n  border-radius: 12px;\n  color: white;\n  text-align: center;\n\n  padding: 2px 10px;\n  margin-top: 10px;\n}\n.workshop-type {\n  width: auto;\n  border-radius: 12px;\n  color: white;\n  text-align: center;\n  padding: 2px 10px;\n  margin-top: 10px;\n}\n\n.labels-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0px 20px;\n  flex-wrap: wrap;\n}\n\n.workshop-bottom-section {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px;\n  color: var(--hydros-blue);\n}\n\n.no-margin {\n  margin: 0;\n}\n\n.workshop-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  border: solid var(--hydros-blue) 4px;\n  border-radius: 20px;\n  padding: 15px;\n  max-width: 400px;\n}\n\n.workshops-list {\n  margin-top: 15px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 15px;\n}\n\n.workshop-name {\n  font-size: 22px;\n  text-align: center;\n  color: var(--hydros-orange);\n  font-weight: bold;\n}\n\n.workshop-button {\n}\n\n.login-page {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 89vh;\n}\n\n.login-container {\n  padding: 15px 30px;\n  border-radius: 15px;\n  background-color: var(--hydros-sand);\n}\n\n.login-title {\n  margin: 0 0 30px 0;\n  color: var(--hydros-orange);\n  font-size: 30px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.form-input-container {\n  font-size: 18px;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n}\n\n.form-input-container:focus {\n  border: 2px solid var(--hydros-orange);\n}\n\n.form-container {\n  width: 400px;\n  margin: 20px auto;\n  padding: 20px;\n  background: var(--hydros-sand);\n  border-radius: 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-top-title {\n  font-size: 40px;\n  margin-bottom: 50px;\n  color: var(--hydros-blue);\n}\n\n.bad-login-div {\n  border: solid rgb(177, 14, 14) 2px;\n  padding: 8px 0px;\n  font-size: 13px;\n  color: rgb(202, 23, 23);\n  background: rgb(228, 181, 181);\n  border-radius: 10px;\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n.icon {\n  font-size: 16px;\n}\n\n.card-indicators {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n}\n\n.card-indicator {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n}\n\n.color-blue {\n  color: var(--hydros-blue);\n}\n\n.input {\n  font-size: 18px;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n  width: calc(100% - 20px);\n}\n\n.input-label {\n  margin-bottom: 10px;\n}\n\n.recap-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 50px;\n  width: 100%;\n  margin-top: 25px;\n}\n\n.back-to-game {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 25px;\n  padding: 15px;\n  border-radius: 15px;\n  background: var(--hydros-orange);\n  color: white;\n  margin-right: 25px;\n  bottom: 0;\n  cursor: pointer;\n  align-self: flex-end;\n}\n\n.back-to-game:hover {\n  background-color: #faa08a;\n}\n\n.happening-text {\n  text-align: center;\n  max-width: 800px;\n  font-size: 18px;\n  color: var(--hydros-blue);\n  font-weight: 600;\n}\n\n.green-bg {\n  color: white;\n  background-color: #176736;\n}\n\n.blue-bg {\n  color: white;\n  background-color: #0e4596;\n}\n\n.white-bg {\n  color: var(--hydros-blue);\n  background-color: white;\n  border: 2px solid var(--hydros-blue);\n}\n\n.red-bg {\n  color: white;\n  background-color: #c72f30;\n}\n\n.orange-bg {\n  color: white;\n  background-color: #ff5b2d;\n}\n.yellow-bg {\n  color: var(--hydros-blue);\n  background-color: #ffcf31;\n}\n.purple-bg {\n  color: white;\n  background-color: #65326b;\n}\n.gray-bg {\n  color: white;\n  background-color: #736e6a;\n}\n\n.pink-bg {\n  color: white;\n  background-color: #f85ca5;\n}\n\n.default-bg {\n  color: white;\n  background-color: var(--hydros-blue);\n}\n\n.tuto-video {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 50px;\n}\n\n.card-bottom-back {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n.datepicker-container {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.ticket-price {\n  font-size: 18px;\n  padding: 10px;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n  width: 50px;\n  margin-right: 5px;\n}\n\n.workshop-description {\n  font-size: 16px;\n  padding: 10px;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n  width: calc(100% - 20px);\n  resize: none;\n}\n\n.description-container {\n  margin: 15px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ticket-price-container {\n  margin: 15px 0px 0px 0px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ticket-price-tooltip {\n  font-size: 14px;\n  margin-bottom: 20px;\n  text-align: end;\n  margin-top: 5px;\n}\n\n.address-container {\n  margin-top: 20px;\n}\n\n.workshop-address {\n  font-size: 18px;\n  padding: 10px;\n  margin: 10px 0;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n  width: calc(100% - 20px);\n}\n\n.workshop-city {\n  font-size: 18px;\n  padding: 10px;\n  margin: 10px 0px 10px 15px;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n  width: calc(50% - 39px);\n}\n\n.workshop-postal-code {\n  font-size: 18px;\n  padding: 10px;\n  margin: 10px 15px 10px 0px;\n  border: 2px solid var(--hydros-orange);\n  border-radius: 10px;\n  width: calc(50% - 39px);\n}\n\n.ticketing-link {\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.ticketing-icon {\n  color: var(--hydros-blue);\n  font-size: 20px;\n}\n\n.ticketing-explanation {\n  margin-bottom: 20px;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 450;\n}\n\n.validate-parameters {\n  font-size: 18px;\n  color: var(--hydros-blue);\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.profile-toolbar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.game-summary-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /*height: 100vh;  Utilisez 100vh pour occuper 100% de la hauteur de la fenêtre */\n}\n\n.context-container {\n  display: block;\n  position: relative;\n  max-height: 1000px;\n  width: 600px;\n  margin: auto;\n  border: 5px solid var(--hydros-blue);\n  border-radius: 15px;\n}\n\n.final-form-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 30px;\n}\n\n.final-form-input {\n  font-size: 18px;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 2px solid var(--hydros-blue);\n  border-radius: 10px;\n}\n\n.final-form-result {\n  padding: 20px;\n  text-align: center;\n  color: #205673;\n  font-size: 25px;\n  font-weight: 600;\n}\n\n.game-summary-title {\n  font-size: 40px; \n  color: var(--hydros-blue);\n  margin-bottom: 0px }\n\n.game-summary-subtitle {\n  font-size: 35px; \n  color: var(--hydros-mid-blue);\n  margin: 0px }\n\n.game-summary-list {\n  font-size: 20px; \n  color: var(--hydros-blue);\n  padding : 0;\n  list-style-type: none }\n  \n.game-summary-text{\n  font-size: 20px; \n  color: var(--hydros-blue);\n  margin : 0}\n\n.game-summary-bold-text{\n  font-size: 20px; \n  font-weight: bold;\n  color: var(--hydros-orange);}\n\n.game-summary-number{\n  font-size: 35px; \n  font-weight: bold;\n  color: var(--hydros-orange);\n  margin:0}\n\n.game-summary-subcontainer-left{\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-content: space-around;\n  margin-left : 25px;\n}\n.game-summary-subcontainer-bottom-left{\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-content: space-around;\n  margin-left : 100px;\n}\n.game-summary-subcontainer-right{\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-content: space-around;\n  margin-right : 100px;\n}\n\n.game-summary-grouped-container{\n  text-align: center;\n  display: flex;\n  align-items: center;\n}\n\n.game-summary-icon{\n  font-size: 70px;\n  color: var(--hydros-orange);\n  align-items: center;\n}\n\n.game-summary-blue-icon{\n  font-size: 70px;\n  color: var(--hydros-blue);\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.separator{\n  margin-bottom: 30px;\n}\n\n\n.qrcode-container {\n  margin-bottom: 20px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
